import React from 'react';
import './ProductCardsSection.scss';
import { useTranslation } from 'react-i18next';
import SimpleBar from 'simplebar-react';
import CustomTooltip from '../../../../../../../shared/components/common/tooltip/CustomTooltip';
import ProductCard from '../../../../../../../shared/components/product-card/ProductCard';
import { ProductItem } from '../../../../../../../shared/models/monitor/ResponseFeatures';

interface ProductCardsSectionProps {
  products: ProductItem[] | null;
}

/** Bottom "Product Cards" strip — newest products captured across the period. */
const ProductCardsSection: React.FC<ProductCardsSectionProps> = ({ products }) => {
  const { t } = useTranslation();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="product-cards-section">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('productCards')}
          <CustomTooltip tooltipText="productCardsTooltip" addMargin={false} />
        </div>
      </div>
      <SimpleBar autoHide={false} style={{ maxWidth: '100%' }}>
        <div className="product-cards-section__list">
          {products.map((product, index) => (
            <ProductCard
              key={`bottom-product-${index}`}
              title={product.title}
              imageUrl={product.imageUrl}
              domain={product.domain}
              url={product.url}
              priceRaw={product.priceRaw}
              priceValue={product.priceValue}
              priceCurrency={product.priceCurrency}
            />
          ))}
        </div>
      </SimpleBar>
    </div>
  );
};

export default ProductCardsSection;
